import React, { useState } from "react";
import type { Offer } from "../../lib/types/detailsTypes";
import ActivatedOffer from "./activatedOffer";
import UnactivateOffer from "./unactivatedOffer";
import { Timestamp } from "firebase/firestore";

interface WalletOfferDetailsDialogProps {
  open: boolean;
  offer: Offer;
  onClose: () => void;
  userId: string;
  onOfferDeleted?: (offerId: string) => void;
}

const WalletOfferDialog: React.FC<WalletOfferDetailsDialogProps> = ({
  open,
  offer,
  onClose,
  userId,
  onOfferDeleted,
}) => {
  // 1. Keep the offer in local state so we can update it when it becomes activated
  const [currentOffer, setCurrentOffer] = useState<Offer>(offer);

  // 2. Callback that updates the offer after activation
  const handleOfferActivated = () => {
    setCurrentOffer((prevOffer) => ({
      ...prevOffer,
      isActivated: true,
      activatedTime: Timestamp.fromDate(new Date()),
    }));
  };

  const handleOfferDeleted = (offerId: string) => {
    if (onOfferDeleted) {
      onOfferDeleted(offerId);
    }
  };

  return (
    <>
      {!currentOffer.isActivated ? (
        <UnactivateOffer
          open={open}
          offer={currentOffer}
          onClose={onClose}
          // Pass in the callback
          onActivate={handleOfferActivated}
          onOfferDeleted={handleOfferDeleted}
          userId={userId}
        />
      ) : (
        <ActivatedOffer
          open={open}
          offer={currentOffer}
          onClose={onClose}
          onOfferDeleted={handleOfferDeleted}
        />
      )}
    </>
  );
};

export default WalletOfferDialog;
